<template>
  <DashboardLayout :breadcrumbs="breadcrumbs">
    <div class="container is-fluid">
      <div class="level">
        <div class="level-left">
          <h1 class="title is-5">{{ $t('routes.employees') }}</h1>
        </div>
        <div class="level-right">
          <div class="field is-grouped controls">
            <div class="control">
              <button @click="goTo('createEmployee')"
                      class="button is-success">
                {{ $t('interface.createNewObject') }}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="level table-actions">
        <div class="level-left">
          <form @submit.prevent="onSearch">
            <div class="field is-grouped controls">
              <div class="control">
                <b-input v-model="q" :placeholder="$t('interface.search')"></b-input>
              </div>
              <div class="control mr-10">
                <button type="submit" class="button is-primary">
                  <b-icon icon="magnify" size="is-small"></b-icon>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <b-table class="mt-10"
               :data="list"
               :loading="loading"

               paginated
               backend-pagination
               :total="total"
               :per-page="perPage"
               @page-change="onPageChange"

               backend-sorting
               default-sort-direction="desc"
               :default-sort="[sortField, sortOrder]"
               @sort="onSort">
        <template slot-scope="props">
          <b-table-column :label="$t('admin.name')" field="fullname" sortable>
            {{ props.row.fullname }}
          </b-table-column>
          <b-table-column :label="$t('admin.login')" field="user__username" sortable>
            {{ props.row.user__username }}
          </b-table-column>
          <b-table-column :label="$t('admin.department')" field="department__name" sortable>
            {{ props.row.department__name }}
          </b-table-column>
          <b-table-column :label="$t('admin.position')" field="position" sortable>
            {{ props.row.position__name }}
          </b-table-column>
          <b-table-column :label="$t('admin.is_dismissed')" field="is_dismissed" sortable>
            {{ props.row.is_dismissed ? $t('interface.y') : $t('interface.n') }}
          </b-table-column>
          <b-table-column width="200">
            <div class="has-text-right">
              <button class="button is-small is-primary mr-5" @click="edit(props.row.id)">
                <b-icon icon="pencil" size="is-small"></b-icon>
              </button>
              <button class="button is-small is-warning" @click="changePassword(props.row.id)">
                {{ $t('routes.changePassword') }}
              </button><!--
              <button class="button is-small is-danger" @click="remove(props.row.id)">
                <b-icon icon="delete" size="is-small"></b-icon>
              </button>-->
            </div>
          </b-table-column>
        </template>

        <template slot="empty">
          <section class="section">
            <div class="content is-fluid has-text-grey has-text-centered">
              <p>Ничего не найдено, попробуйте <a class="is-dashed" @click.prevent="resetFilters">сбросить фильтры и
                поиск</a>.</p>
            </div>
          </section>
        </template>
      </b-table>
    </div>
    <b-modal class="dialog" :active.sync="passwordChangeModal" has-modal-card>
      <div class="modal-card" style="width: auto">
        <section class="modal-card-body is-titleless">
          <form-input autocomplete="new-password" class="mb-5" type="password" v-model="password.password" :label="$t('admin.password')"></form-input>
          <form-input autocomplete="new-password" type="password" v-model="password.repeat" :label="$t('admin.password2')"></form-input>
        </section>
        <footer class="modal-card-foot">
          <button class="button is-primary" @click="passwordSubmit">ОК</button>
          <button class="button is-danger" type="button" @click="passwordChangeModal = false">
            {{ $t('interface.cancel') }}
          </button>
        </footer>
      </div>
    </b-modal>
  </DashboardLayout>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import {priorityColors, stateColors} from '@/colorTypes'
  import DashboardLayout from '@/components/DashboardLayout'
  import GovernmentAgencySelect from '@/components/GovernmentAgencySelect'
  import {deleteObjectKeysByValue} from '@/utils'

  export default {
    components: {
      DashboardLayout,
      GovernmentAgencySelect
    },
    data() {
      return {
        loading: false,
        total: 0,
        page: 1,
        perPage: 15,
        q: '',
        sortField: '',
        sortOrder: 'desc',
        priorityColors,
        stateColors,
        passwordChangeModal: false,
        password: {
          id: null,
          password: '',
          repeat: ''
        }
      }
    },
    methods: {
      loadData() {
        this.loading = true
        this.checkedRows = []
        let params = {
          page: this.page,
          page_size: this.perPage,
          q: this.q,
          ordering: `${this.sortOrder === 'desc' ? '-' : ''}${this.sortField}`,
        }
        this.$store.dispatch('Moderator/getList', {actionType: 'employees', params}).then((response) => {
          this.loading = false
          this.total = response.count
        })
      },
      onSort(field, order) {
        this.sortField = field
        this.sortOrder = order
        this.loadData()
      },
      onPageChange(page) {
        this.page = page
        this.loadData()
      },
      onSearch() {
        this.loadData()
      },
      goTo(route) {
        this.$router.push({name: route})
      },
      edit(id) {
        this.$router.push({name: 'editEmployee', params: {id}})
      },
      remove(id) {
        this.$dialog.confirm({
          title: `Подтвердите действие`,
          message: `Вы уверены, что хотите удалить запись?`,
          confirmText: this.$t('interface.remove'),
          cancelText: this.$t('interface.cancel'),
          type: 'is-danger',
          hasIcon: true,
          onConfirm: () =>
            this.$store.dispatch('Moderator/remove', {actionType: 'employees', id}).then(() => this.loadData())
        })
      },
      changePassword(id) {
        this.passwordChangeModal = true
        this.password.id = id
      },
      passwordSubmit() {
        if (this.password.password === this.password.repeat && this.password.password.length > 0) {
          this.$store.dispatch('Moderator/changePassword', this.password).then(() => this.passwordChangeModal = false)
        } else {
          this.$toast.open({
            message: this.$t('admin.passwordsWrong'),
            type: 'is-danger'
          })
        }
      }
    },
    computed: {
      ...mapState('Moderator', ['list']),
      checkedRowsCount() {
        return this.checkedRows.length
      },
      breadcrumbs() {
        return [
          {name: 'employees'}
        ]
      }
    },
    mounted() {
      this.loadData()
      this.$store.dispatch('IssueTracker/getRelations')
    }
  }
</script>
